'use client';
import * as React from 'react';
import { Dialog } from '@/components/dialog';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import useDialog from '@/hooks/useDialog';

const DialogWrapper = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ children, ...props }, ref) => {
  const { open, onOpenChange } = useDialog();

  // NOTE: onOpenChange内でモーダルの開閉とスクロールの有無を管理しており、
  //       モーダルが意図せず閉じた場合にスクロール禁止状態が続いてしまう。
  //       なのでunmount時に必ずonOpenChangeを実行してスクロール禁止を解除する
  React.useEffect(() => () => onOpenChange(false), []);

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange} modal={false}>
        {children}
      </Dialog>
    </>
  );
});

export { DialogWrapper };
